
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductInspectionGrid extends Serenity.EntityGrid<ProductInspectionRow, any> {
        protected getColumnsKey() { return 'OMS.ProductInspection'; }
        protected getDialogType() { return ProductInspectionDialog; }
        protected getIdProperty() { return ProductInspectionRow.idProperty; }
        protected getInsertPermission() { return ProductInspectionRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductInspectionRow.localTextPrefix; }
        protected getService() { return ProductInspectionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}